import { render, staticRenderFns } from "./ReportReworks.vue?vue&type=template&id=0b13bfa6&scoped=true&"
import script from "./ReportReworks.vue?vue&type=script&lang=js&"
export * from "./ReportReworks.vue?vue&type=script&lang=js&"
import style0 from "./ReportReworks.vue?vue&type=style&index=0&id=0b13bfa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13bfa6",
  null
  
)

export default component.exports
import {QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign({QTr,QTh,QTd}, component.options.components || {})
